module.exports = __webpack_public_path__ + "img/SOKAL-SRS-112921-Telluride-Lifestyle.9502cfef.jpeg";